import { useAccountId, FileUploadWithLoader } from '@labrav/common'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  BoxV2,
  CheckBoxFieldv2,
  LabraToolTipV2,
  NoteV2,
} from '@labrav/react-components'
import React from 'react'
import { useStyles } from './FlyOutNotificationsSettings.styles'
import { FormikHandlers, FormikProps, useFormikContext } from 'formik'
import { Typography } from '@mui/material'
import { faGear } from '@fortawesome/pro-regular-svg-icons'
import { FormLockedType } from '../../../types/FormLockedType'
import { DefaultNowType } from '../../../common/utils/dateTimeNow'
import { isEmpty } from 'lodash'
import { bucketName } from '../../../common/utils/constants'
import clsx from 'clsx'
import { FlyoutProductSections } from '../../../types/addEditProduct'
import {
  fileFormatIncorrectText,
  fileUploadButtonText,
  fileUploadContainerTitle,
  notificationImageFileUploadDescription,
} from '../../../common/utils/productCreationUtil'
import { FlyoutProductNotificationSettingsFaqs } from './FlyoutNotificationSettingsFaqs'
export interface FlyOutNotificationsSettingsProps {
  now: DefaultNowType
  detailView?: boolean
  detailViewTooltip?: string
}

export const FlyOutNotificationsSettings: React.FC<
  FlyOutNotificationsSettingsProps & FormLockedType
> = ({ now, isFormLocked, detailView, detailViewTooltip }) => {
  const { values, handleChange, setFieldValue } =
    useFormikContext() as FormikProps<FlyoutProductSections>
  const generalInformation = values.generalInformation
  const accountId = useAccountId({ product: 'flyout' }) || ''

  const [indexModal, setIndexModal] = React.useState(0)

  const updateProductLogoUrl = (imageUrl: string) => {
    setFieldValue('generalInformation.headerImg', imageUrl)
  }
  const deleteProductLogoUrl = () => {
    setFieldValue('generalInformation.headerImg', '')
  }

  const handleCheckboxChange =
    (handleChange: FormikHandlers['handleChange']) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChange({
        target: {
          name: 'generalInformation.buyerNotificationsAllowed',
          value: !e.target.checked,
        },
      })
    }

  const { classes } = useStyles()
  return (
    <BoxV2
      heading={'Buyer notifications settings'}
      headingIcon={
        <FontAwesomeIcon
          icon={faGear}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={
        <FlyoutProductNotificationSettingsFaqs
          indexModal={indexModal}
          setIndexModal={setIndexModal}
        />
      }
    >
      <div
        className={classes.marginBottom}
        data-testid="notifications-settings"
      >
        <div className={clsx(classes.rootContainer, classes.marginBottom)}>
          <Typography className={classes.subHeading}>
            Choose whether you want to disable all emails sent to your buyer via
            this platform.
          </Typography>
          <div className={classes.checkBoxRootContainer}>
            <div className={classes.checkBoxContainer} data-testid="checkbox">
              <CheckBoxFieldv2
                keyName="buyerNotificationsAllowed"
                title="Disable the emails to buyers via platform."
                value={!generalInformation.buyerNotificationsAllowed}
                onChangeBox={handleCheckboxChange(handleChange)}
                disabled={isFormLocked || detailView}
              />
            </div>
            <Typography
              className={clsx(classes.sectionText, classes.optionalText)}
            >
              Optional
            </Typography>
          </div>
          {!generalInformation.buyerNotificationsAllowed && (
            <div className={classes.note}>
              <NoteV2 description="Your buyer will not receive any confirmation from platform upon successful purchase of your listing or acceptance of your private offer. These emails will have to be handled by you as the seller." />
            </div>
          )}
        </div>
        <div
          className={classes.sectionContainer}
          data-testid="file-uploader-header-logo"
        >
          <div className={classes.textContainer}>
            <div className={classes.sectionHeadingContainer}>
              {' '}
              <Typography
                className={classes.sectionHeading}
                data-testid="section-heading"
              >
                Customized logo on the buyer notifications
              </Typography>
              <Typography
                className={classes.sectionText}
                data-testid="optional"
              >
                Optional
              </Typography>
            </div>
            <Typography
              className={classes.sectionText}
              data-testid="section-text"
            >
              Add a custom logo which will be present as a banner at the top of
              the email sent to your buyer via this platform. (Refer to number 1
              in third image).
            </Typography>
          </div>
          <LabraToolTipV2
            followCursor={detailView}
            tooltipPlacement="bottom-start"
            description={detailViewTooltip}
          >
            <FileUploadWithLoader
              keyName={'logo-upload-header-image'}
              partnerId={accountId}
              existingFileLinks={
                isEmpty(generalInformation?.headerImg)
                  ? []
                  : [generalInformation?.headerImg]
              }
              assetType="email_assets"
              folder="header"
              fileUploadDescription={notificationImageFileUploadDescription}
              quantity={1}
              fileUploadType="png/jpg"
              unit="MB"
              uploadFileSize={5}
              acceptedFormats={['.png', '.jpg']}
              updateUrl={updateProductLogoUrl}
              deleteUrl={deleteProductLogoUrl}
              defaultNow={now}
              fileUploadButtonText={fileUploadButtonText}
              fileFormatIncorrectText={fileFormatIncorrectText}
              fileUploadContainerTitle={fileUploadContainerTitle}
              bucketName={bucketName}
              disabled={isFormLocked || detailView}
              aspectRatios={['6:1']}
              maxPixels={1200}
              minPixels={600}
              viewOnly={detailView}
              checkDuplicate
              showRealFileName
            />
          </LabraToolTipV2>
        </div>
      </div>
    </BoxV2>
  )
}
